export const fileUpdateMessage = (body, previousName) => {
  const next = body?.displayName ?? body?.name
  if (next != null && previousName != null && String(next).trim() !== String(previousName).trim()) return 'File renamed.'
  return 'File details saved.'
}
